import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  setDoc,
  updateDoc,
} from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { COL, type Banner } from '@eprintsmart/shared';
import { db, storage } from '../firebase';

/** CRUD for the home-hero marketing banners. Images live in Storage under
 * banners/{id}/; the doc keeps the public download URL. */

const banners = () => collection(db, COL.banners);

export function watchBanners(cb: (rows: Banner[]) => void): () => void {
  return onSnapshot(query(banners(), orderBy('order')), (snap) =>
    cb(snap.docs.map((d) => ({ ...(d.data() as Banner), id: d.id }))),
  );
}

export async function uploadBannerImage(bannerId: string, file: File): Promise<string> {
  const ext = file.name.split('.').pop() || 'jpg';
  const r = ref(storage, `banners/${bannerId}/image.${ext}`);
  await uploadBytes(r, file, { contentType: file.type });
  return getDownloadURL(r);
}

export async function createBanner(input: {
  imageFile: File;
  alt?: string;
  linkUrl?: string;
  order: number;
}): Promise<void> {
  const id = doc(banners()).id;
  const now = Date.now();
  const imageUrl = await uploadBannerImage(id, input.imageFile);
  await setDoc(doc(banners(), id), {
    id,
    imageUrl,
    ...(input.alt ? { alt: input.alt } : {}),
    ...(input.linkUrl ? { linkUrl: input.linkUrl } : {}),
    order: input.order,
    active: true,
    createdAt: now,
    updatedAt: now,
  });
}

export async function updateBanner(id: string, patch: Partial<Banner>): Promise<void> {
  await updateDoc(doc(banners(), id), { ...patch, updatedAt: Date.now() });
}

export async function deleteBanner(id: string): Promise<void> {
  await deleteDoc(doc(banners(), id));
}
